import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, Request, RequestOptions, URLSearchParams, RequestMethod } from '@angular/http';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { TranslateService } from './translate.service';
import { ApiRequestService } from './api-request.service';
import { CriteriaIO, SearchCriteriaDO } from '../../shared/models';

@Injectable()
export class LeadService {

    constructor(
        private apiRequest: ApiRequestService,
        private translate: TranslateService
    ) { }

    //saveLeads(lead/save),getLead(lead/fetchById),getLeads(lead/fetchAll)
    //services added -BHAWNA

    //save a single lead
    saveLeads(leadIO): Observable<any> {
        let self = this;
        let leadDataSubject: Subject<any> = new Subject<any>();
        this.apiRequest.post('lead/save', leadIO)
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    console.log("Lead save successful")
                    console.log(jsonResp)
                } else {
                    console.log("Lead save failed")
                    console.log(jsonResp)
                }
                leadDataSubject.next(jsonResp);

            }, errResp => {
                leadDataSubject.next(errResp);
            })
        return leadDataSubject;
    }


    //Fetch a single Lead based on id

    getLead(id: number): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();

        params.set('id', typeof id === "number" ? id.toString() : "0");

        let leadDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1);
        this.apiRequest.get('lead/fetchById/' + id)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                leadDataSubject.next(returnObj);
            });

        return leadDataSubject;
    }

    //Fetch all Lead
    getLeads(): Observable<any> {
        let me = this;

        let leadDataSubject = new Subject<any>();

        this.apiRequest.get('lead/fetchAll/')
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                leadDataSubject.next(returnObj);
            });

        return leadDataSubject;
    }


    // get lead by search criteria
    searchLead(searchParam): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();
        console.log(searchParam);
        var criteriaArray = Object.keys(searchParam).map(function (key) { return searchParam[key]; });

        let criteria: CriteriaIO[] = [];
        var criteriaObj = new CriteriaIO();

        let searchCriteriaList : SearchCriteriaDO[] = [];

        var searchCriteriaDO1 = new SearchCriteriaDO();
        searchCriteriaDO1.setParamName("agentCd");
        searchCriteriaDO1.setParamValue(criteriaArray[0]);
        searchCriteriaList.push(searchCriteriaDO1);

        var searchCriteriaDO2 = new SearchCriteriaDO();
        searchCriteriaDO2.setParamName("statusCd");
        searchCriteriaDO2.setParamValue(criteriaArray[1]);
        searchCriteriaList.push(searchCriteriaDO2);

        // criteriaObj.setParamName("criteria");
        // criteriaObj.setParamValue(criteriaArray);
        // criteria.push(criteriaObj);

        criteriaObj.setSearchCriteriaList(searchCriteriaList);

        let leadSearchData: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want after ajax search policy attempt
        // let searchURL = 'lead/search/' + criteriaArray;      //only individual lead details
        let searchURL = 'lead/searchPortal';  // include corporate lead details
        var returnObj = "success";
        this.apiRequest.post(searchURL, criteriaObj)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                leadSearchData.next(returnObj);
            });
        return leadSearchData;
    }

    saveLeadActivity(leadActivityObj, leadNum: number): Observable<any> {
        let self = this;
        let leadDataSubject: Subject<any> = new Subject<any>();
        this.apiRequest.post('lead/addLeadActivity/' + leadNum, leadActivityObj)
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    console.log("Lead Activity save successful")
                    console.log(jsonResp)
                } else {
                    console.log("Lead Activity save failed")
                    console.log(jsonResp)
                }
                leadDataSubject.next(jsonResp);

            }, errResp => {
                leadDataSubject.next(errResp);
            })
        return leadDataSubject;
    }

    // get lead by search criteria by pagination
    searchLeadByPagination(searchParam, pageNum, pageSize): Observable<any> {
        let me = this;
        var criteriaArray = Object.keys(searchParam).map(function (key) { return searchParam[key]; });

        let params: URLSearchParams = new URLSearchParams();
        console.log(searchParam);


        let criteria: CriteriaIO[] = [];
        var criteriaObj = new CriteriaIO();
        // criteriaObj.setParamName("criteria");
        // criteriaObj.setParamValue(criteriaArray);
        // criteria.push(criteriaObj);

        // // In case of pagination use below code [Highlighted in yellow]
        // criteriaObj = new CriteriaIO();
        // criteriaObj.setParamName("page");
        // criteriaObj.setParamValue([pageNum]);
        // criteria.push(criteriaObj);

        // criteriaObj = new CriteriaIO();
        // criteriaObj.setParamName("size");
        // criteriaObj.setParamValue([pageSize]);
        // criteria.push(criteriaObj);

        criteriaObj.setPage(pageNum);
        criteriaObj.setSize(pageSize);

        let searchCriteriaList : SearchCriteriaDO[] = [];

        var searchCriteriaDO1 = new SearchCriteriaDO();
        searchCriteriaDO1.setParamName("agentCd");
        searchCriteriaDO1.setParamValue(criteriaArray[0]);
        searchCriteriaList.push(searchCriteriaDO1);

        var searchCriteriaDO2 = new SearchCriteriaDO();
        searchCriteriaDO2.setParamName("statusCd");
        searchCriteriaDO2.setParamValue(criteriaArray[1]);
        searchCriteriaList.push(searchCriteriaDO2);

        // criteriaObj.setParamName("criteria");
        // criteriaObj.setParamValue(criteriaArray);
        // criteria.push(criteriaObj);

        criteriaObj.setSearchCriteriaList(searchCriteriaList);

        let leadSearchData: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want after ajax search policy attempt
        // let searchURL = 'lead/search/' + criteriaArray;      //only individual lead details
        let searchURL = 'lead/searchPortalWithPagination';  // include corporate lead details
        var returnObj = "success";
        this.apiRequest.post(searchURL, criteriaObj)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                leadSearchData.next(returnObj);
            });
        return leadSearchData;
    }

 
    // get lead by advance search criteria by pagination
    advanceSearchLeadByPagination(searchParam, pageNum, pageSize): Observable<any> {
        let me = this;																							  

        let params: URLSearchParams = new URLSearchParams();
        console.log(searchParam);
        var criteriaArray = Object.keys(searchParam).map(function (key) { return searchParam[key]; });

        let criteria: CriteriaIO[] = [];
        var criteriaObj = new CriteriaIO();
        // criteriaObj.setParamName("criteria");
        // criteriaObj.setParamValue(criteriaArray);
        // criteria.push(criteriaObj);

        // // In case of pagination use below code [Highlighted in yellow]
        // criteriaObj = new CriteriaIO();
        // criteriaObj.setParamName("page");
        // criteriaObj.setParamValue([pageNum]);
        // criteria.push(criteriaObj);

        // criteriaObj = new CriteriaIO();
        // criteriaObj.setParamName("size");
        // criteriaObj.setParamValue([pageSize]);
        // criteria.push(criteriaObj);								

        criteriaObj.setPage(pageNum);
        criteriaObj.setSize(pageSize);

        let searchCriteriaList : SearchCriteriaDO[] = [];

        var searchCriteriaDO1 = new SearchCriteriaDO();
        searchCriteriaDO1.setParamName("agentCd");
        searchCriteriaDO1.setParamValue(criteriaArray[0]);
        searchCriteriaList.push(searchCriteriaDO1);

        var searchCriteriaDO2 = new SearchCriteriaDO();
        searchCriteriaDO2.setParamName("statusCd");
        searchCriteriaDO2.setParamValue(criteriaArray[1]);
        searchCriteriaList.push(searchCriteriaDO2);

        var searchCriteriaDO3 = new SearchCriteriaDO();
        searchCriteriaDO3.setParamName("firstName");
        searchCriteriaDO3.setParamValue(criteriaArray[2]);
        searchCriteriaList.push(searchCriteriaDO3);

        var searchCriteriaDO4 = new SearchCriteriaDO();
        searchCriteriaDO4.setParamName("lastName");
        searchCriteriaDO4.setParamValue(criteriaArray[3]);
        searchCriteriaList.push(searchCriteriaDO4);

        var searchCriteriaDO5 = new SearchCriteriaDO();
        searchCriteriaDO5.setParamName("emailId");
        searchCriteriaDO5.setParamValue(criteriaArray[4]);
        searchCriteriaList.push(searchCriteriaDO5);

        var searchCriteriaDO6 = new SearchCriteriaDO();
        searchCriteriaDO6.setParamName("contactNum");
        searchCriteriaDO6.setParamValue(criteriaArray[5]);
        searchCriteriaList.push(searchCriteriaDO6);

        var searchCriteriaDO7 = new SearchCriteriaDO();
        searchCriteriaDO7.setParamName("dob");
        searchCriteriaDO7.setParamValue(criteriaArray[6]);
        searchCriteriaList.push(searchCriteriaDO7);

        var searchCriteriaDO8 = new SearchCriteriaDO();
        searchCriteriaDO8.setParamName("leadNum");
        searchCriteriaDO8.setParamValue(criteriaArray[7]);
        searchCriteriaList.push(searchCriteriaDO8);

        var searchCriteriaDO9 = new SearchCriteriaDO();
        searchCriteriaDO9.setParamName("companyName");
        searchCriteriaDO9.setParamValue(criteriaArray[8]);
        searchCriteriaList.push(searchCriteriaDO9);
        
        var searchCriteriaDO10 = new SearchCriteriaDO();
        searchCriteriaDO10.setParamName("contactPersonName");
        searchCriteriaDO10.setParamValue(criteriaArray[9]);
        searchCriteriaList.push(searchCriteriaDO10);
        
        criteriaObj.setSearchCriteriaList(searchCriteriaList);

        let leadSearchData: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want after ajax search policy attempt
        // let searchURL = 'lead/search/' + criteriaArray;      //only individual lead details
        let searchURL = 'lead/searchPortalWithoutPagination';  // include corporate lead details
        var returnObj = "success";
        this.apiRequest.post(searchURL, criteriaObj)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                leadSearchData.next(returnObj);
            });
        return leadSearchData;
    }

}
